import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { AppProviders } from "./app/providers/AppProviders";
import "./styles/global.css";
import "./styles/layout.css";
import "./styles/arch-designer.css";
import "./styles/prescription-workbench.css";
import "./styles/intro.css";
import "./styles/architecture.css";
import "./styles/split-view.css";



ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <AppProviders>
      <App />
    </AppProviders>
  </React.StrictMode>
);